import styled from "styled-components"

export const StyledTextFieldFormItem = styled.div`
  --label-width: 90px;
  display: flex;
  position: relative;
  width: 100%;

  --input-padding: 16px;
`
export const StyledLabel = styled.label`
  font-size: 16px;
  line-height: 120%;
`

export const StyledInput = styled.input<{
  $isError: boolean
  $disabled?: boolean
}>`
  background: var(--white-white-5, rgba(255, 255, 255, 0.049));
  border-radius: 8px;
  backdrop-filter: blur(60px);
  padding: 31px 16px;
  padding-left: var(--label-width);
  line-height: 26px;
  font-weight: 700;
  border-radius: 8px;

  border: 1px solid
    ${(props) =>
      props.$isError
        ? "var(--secondary-yellow-amber, #FFC800)"
        : "transparent"};

  color: ${(props) =>
    props.$isError
      ? "var(--secondary-yellow-amber, #FFC800)"
      : props.$disabled
      ? "var(--white-white-50, rgba(255, 255, 255, 0.50))"
      : "var(--Data_Dinner, #14C9C9)"};

  text-align: right;
  width: 100%;
  height: 100%;
  font-size: 16px;

  &:focus,
  &:active,
  &:focus-visible {
    outline: none;
    border: 1px solid
      ${(props) =>
        props.$isError
          ? "var(--secondary-yellow-amber, #FFC800)"
          : "var(--Schemes-Primary, #0da3ba)"};
  }

  &::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    color: var(--White-White, #fff);
    font-size: 16px;
    font-weight: 400;
    opacity: 0.5;
  }

  &::-moz-placeholder {
    /* Firefox 19+ */
    color: var(--White-White, #fff);
    font-size: 16px;
    font-weight: 400;
    opacity: 0.5;
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  &[type="number"] {
    -moz-appearance: textfield;
  }
`

export const DetailsTrailing = styled.div<{ $isUnit?: boolean }>`
  position: absolute;
  right: var(--input-padding);
  top: 50%;
  transform: translateY(-50%);
  font-size: 16px;
  color: var(--White_40, rgba(255, 255, 255, 0.4));
  pointer-events: none;
  ${(props) =>
    props.$isUnit &&
    `
    color: var(--Schemes-Primary, #0DA3BA);
    font-weight: 500;
    `}
`

export const LabelBox = styled.div`
  position: absolute;
  text-align: left;
  left: var(--input-padding);
  top: 50%;
  transform: translateY(-50%);
  color: var(--White-White, #fff);
  z-index: 10;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: var(--label-width);
  pointer-events: none;
`

export const PercentLabel = styled(StyledLabel)`
  color: var(--Primitive-White_60, rgba(255, 255, 255, 0.6));
  font-weight: 600;
  pointer-events: none;
`
